<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-6"></div>
                                    <div class="col-md-3 d-flex justify-content-end align-items-center">
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            menu-class="dropdown-menu-250"
                                            class="mr-2"
                                            right
                                            v-b-tooltip.hover
                                            :title="$t('label.filter')"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('label.type') }}
                                                </label>
                                                <multiselect
                                                    v-model="orientationType"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="orientationTypeDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                        <b-button
                                            variant="info"
                                            v-on:click="openForm"
                                            v-b-tooltip.hover
                                            :title="$t('label.createX', [])"
                                        >
                                            <i class="mdi mdi-plus"></i>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(header)="data">
                                    <span>{{ data.item.header?.name || '--' }}</span>
                                </template>
                                <template #cell(usageType)="data">
                                    <b-badge :variant="data.item.header?.usageType == 1 ? 'info' : 'primary'">
                                        {{ orientationTypeDdl.find(item => item.value == data.item.header?.usageType)?.text || '--' }}
                                    </b-badge>
                                </template>
                                <template #cell(user)="data">
                                    <span>{{ data.item.user ? data.item.user.fullName || `${data.item.user.firstName || ''} ${data.item.user.lastName || ''}`.trim() || '--' : '--' }}</span>
                                </template>
                                <template #cell(email)="data">
                                    <span>{{ data.item.user?.email || '--' }}</span>
                                </template>
                                <template #cell(company)="data">
                                    <span v-if="data.item.user?.userCompanies?.some(item => item.company?.name)"><template v-for="(assignment, index) in data.item.user.userCompanies.filter(item => item.company?.name)"><span v-if="index" :key="`${index}-separator`">, </span><CompanyLink :key="assignment.uuid || index" :company="assignment.company" /></template></span><span v-else>--</span>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info"
                                        v-b-tooltip.hover
                                        :title="$t('label.updateX', [])"
                                        @click.stop="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="data.item.isActive==0?$t('label.restoreX', []):$t('label.deleteX', [])"
                                        v-on:click="deleteConfirmation(data.item)"
                                    >
                                        <i :class="[`mdi font-size-18 mdi-delete-${data.item.isActive==0?'restore':'outline'}`]"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="orientation-module-assignment-form"
            :title="$t(orientationModuleAssignment.uuid ? 'label.updateX' : 'label.createX', [$t('module.assignment')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            size="lg"
            centered
        >
            <b-container fluid>
                <OrientationModuleAssignmentForm
                    :orientationModuleAssignmentUUID="orientationModuleAssignment.uuid"
                    :searchCriteria="searchCriteria"
                    @done="closeForm"
                    ref="orientationModuleAssignmentForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="orientation-module-assignment-delete"
            :title="orientationModuleAssignment.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
            @hidden="closeForm"
            hide-header-close
        >
            <p class="my-4">{{ orientationModuleAssignment.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('orientation-module-assignment-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestDelete"
                    :disabled="!status.save"
                >
                    {{ orientationModuleAssignment.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED, ORIENTATION_TYPE } from "@/constants";
import { sessionHelper } from "@/utils";
import { mapState } from "vuex";
import { orientationModuleAssignmentMethods } from "@/state/api";
import { ORIENTATION_MODULE_ASSIGNMENT_MODULE } from "@/state/api/orientationModuleAssignment.state";
import OrientationModuleAssignmentForm from "@/views/pages/admin/orientationModuleAssignment/orientationModuleAssignmentForm";

export default {
    components: { Multiselect, OrientationModuleAssignmentForm },
    created() {
        sessionHelper.clearSearch(SESSION.ORIENTATION_MODULE_ASSIGNMENT_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();
    },
    data() {
        return {
            filter: "",
            searchCriteria: {},
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            orientationTypeDdl: ORIENTATION_TYPE,
            orientationType: ORIENTATION_TYPE[0],
            fields: [
                { key: 'header', label: i18n.t("module.header"), sortable: true, class: 'text-nowrap' },
                { key: 'usageType', label: i18n.t("label.type"), sortable: false, class: 'text-nowrap' },
                { key: 'user', label: i18n.t("module.user"), sortable: false, class: 'text-nowrap' },
                { key: 'email', label: i18n.t("label.email"), sortable: false, class: 'text-nowrap' },
                { key: 'company', label: i18n.t("module.company"), sortable: false, class: 'text-nowrap' },
                { key: 'startDate', label: i18n.t("label.startDate"), sortable: true, class: 'text-nowrap' },
                { key: 'endDate', label: i18n.t("label.endDate"), sortable: true, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            orientationModuleAssignment: {
                uuid: "",
                isActive: false,
            },
        };
    },
    methods: {
        ...orientationModuleAssignmentMethods,
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.ORIENTATION_MODULE_ASSIGNMENT_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.ORIENTATION_MODULE_ASSIGNMENT_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: 1,
                    usageType: null,
                    searchValue: "",
                    searchArray: [],
                };
            }
            this.getOrientationModuleAssignmentList(this.searchCriteria);
        },
        getOrientationModuleAssignmentList(filter) {
            this.getAllOrientationModuleAssignment({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.ORIENTATION_MODULE_ASSIGNMENT_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.ORIENTATION_MODULE_ASSIGNMENT_SEARCH);
            filter.pageNumber = pageNumber;
            this.getOrientationModuleAssignmentList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            if (this.orientationType.value == 0)
                delete this.searchCriteria.usageType;
            else
                this.searchCriteria.usageType = this.orientationType.value;
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getOrientationModuleAssignmentList(this.searchCriteria);
        },
        deleteConfirmation(data) {
            this.orientationModuleAssignment = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('orientation-module-assignment-delete');
        },
        requestDelete() {
            let data = {
                uuid: this.orientationModuleAssignment.uuid,
                isActive: this.orientationModuleAssignment.isActive == 0 ? 1 : 0,
            };
            this.updateOrientationModuleAssignmentStatus({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('orientation-module-assignment-delete');
                }));
        },
        openForm(data) {
            if (data?.uuid) {
                this.orientationModuleAssignment = {
                    uuid: data.uuid,
                    isActive: data.isActive,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('orientation-module-assignment-form');
            });
        },
        closeForm() {
            this.orientationModuleAssignment = {
                uuid: "",
                isActive: false,
            };
            this.$bvModal.hide('orientation-module-assignment-form');
        },
    },
    computed: {
        ...mapState(ORIENTATION_MODULE_ASSIGNMENT_MODULE, ['status']),
        tableRows() {
            return this.$store.state.api.orientationModuleAssignment.list.data || [];
        },
        totalPage() {
            return this.$store.state.api.orientationModuleAssignment.list.pagination.total || 0;
        },
    },
}
</script>

